// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    comments: t.Bool,
    customerResolution: t.Bool,
    deliveryDate: t.Bool,
    failurePartNumber: t.Bool,
    pin: t.Bool,
    reasonForReturn: t.Bool,
    responsibleAccount: t.Bool,
    returnDate: t.Bool,
    workOrderOne: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    comments: true,
    customerResolution: true,
    deliveryDate: true,
    failurePartNumber: true,
    pin: true,
    reasonForReturn: true,
    responsibleAccount: true,
    returnDate: true,
    workOrderOne: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/state/form-validation.js